module.exports = "/assets/data/06c4b8b781d7eb25476d9231aa0f7280-DA13.data.json";